import { EscrowStatusEnum, InvitationStatusEnum } from 'src/graphql/schema';
import { OtherEscrowStatusEnum } from 'src/shared/constants';

import type { ISoftwareEscrowQuery } from 'src/graphql/actions/softwareEscrow/softwareEscrow.query';

const getEscrowStatus = ({
  escrowStatus,
  escrowAgreementApproved,
  escrowTermination,
  escrowInvitationStatus,
  pendingActivation,
}: {
  escrowStatus: EscrowStatusEnum;
  escrowAgreementApproved: boolean;
  escrowTermination?: ISoftwareEscrowQuery['softwareEscrow']['escrowTermination'];
  escrowInvitationStatus?: InvitationStatusEnum;
  pendingActivation: boolean;
}) => {
  let status: EscrowStatusEnum | OtherEscrowStatusEnum = escrowStatus;

  if (escrowInvitationStatus === InvitationStatusEnum.Rejected) status = OtherEscrowStatusEnum.Rejected;

  if (pendingActivation) status = OtherEscrowStatusEnum.ActivationProcess;

  if (escrowStatus === EscrowStatusEnum.Onboarding && escrowAgreementApproved)
    status = OtherEscrowStatusEnum.AwaitingSignature;

  if (
    [EscrowStatusEnum.Onboarding, EscrowStatusEnum.Signed, EscrowStatusEnum.Active].includes(escrowStatus) &&
    escrowTermination
  )
    status = OtherEscrowStatusEnum.TerminationRequested;

  return status;
};

export { getEscrowStatus };
